export default {
  props: {
    mode: String,
  },
  data() {
    return {
      //   mode: "SCHEME",
    } as API_HELPER_TABLE;
  },
};